export default function init_detect_touch_device(app) {
    function on_is_touch_device() {
        document.body.classList.add('is-touch-device');

        app.detectTouchDevice.off('is-touch', on_is_touch_device);
    }

    app.detectTouchDevice.on('is-touch', on_is_touch_device);
}